export const digitalMarketingTipsFaqs = [
  {
    question: "Where should an Essex SME start with digital marketing?",
    answer:
      "Choose one priority service, a realistic service area and a measurable customer action. Check that the website explains the offer, the enquiry route works and the business information is accurate before adding more channels or increasing advertising spend.",
  },
  {
    question: "Does a business need a separate page for every Essex town?",
    answer:
      "Only create a location page when it provides useful, distinct information for customers in that area. Relevant projects, service details and practical coverage information can justify a page. Repeating the same copy with different town names does not create a useful local resource.",
  },
  {
    question: "How much should a small business budget for digital marketing?",
    answer:
      "The budget depends on the service being promoted, the audience, competition, website readiness and the amount of work needed. Separate planning and delivery costs from advertising spend, and agree the scope and measurement approach before committing. A focused review can help identify the most useful starting point.",
  },
  {
    question:
      "Can Web Wonderland improve our existing website and marketing together?",
    answer:
      "Yes. Web Wonderland can connect website improvements, local search foundations, content, social media, campaigns and measurement around the same business goal. We assess the existing website and available evidence before recommending a defined next step.",
  },
]
